import { RootState } from 'config/store';
import { TeamsState } from './reducer';
import { Team } from './types';
import { ArchiveFilterValue } from 'components/new-ui/composed/archive-filter/ArchiveFilter';

export const selectTeamsState = (root: { teams: TeamsState }) => root.teams;
export const selectAllTeams = (root: { teams: TeamsState }): Team[] => {
    const s = selectTeamsState(root);
    return s.ids.map((id) => s.entities[id]);
};
export const selectTeamsPage = (s: RootState) => s.teams.page;
export const selectTeamById = (id: string) => (root: { teams: TeamsState }) => selectTeamsState(root).entities[id];
export const selectTeamsLoading = (root: { teams: TeamsState }) => root.teams.loading;
export const selectTeamsError = (root: { teams: TeamsState }) => root.teams.error;
export const selectSelectedTeamId = (root: { teams: TeamsState }) => root.teams.selectedId;
export const selectSelectedTeam = (root: { teams: TeamsState }) => {
    const s = root.teams;
    return s.selectedId ? s.entities[s.selectedId] : undefined;
};
export const selectTeamsResult = (s: RootState) => {
    const list = selectAllTeams(s);
    const page = selectTeamsPage(s);
    return {
        list,
        pageNumber: page?.pageNumber ?? 0,
        pageSize: page?.pageSize ?? list.length,
        total: page?.total ?? list.length,
    };
};
export const selectArchivationStatusFilter = (state: RootState): ArchiveFilterValue =>
    state.teams.archivationStatus || 'active';
export const selectTeamInvoicesCount = (teamId?: string) => (root: { teams: TeamsState }) =>
    teamId ? root.teams.invoicesCounts[teamId] ?? 0 : 0;
export const selectTeamManifestsCount = (teamId?: string) => (root: { teams: TeamsState }) =>
    teamId ? root.teams.manifestsCounts[teamId] ?? 0 : 0;
export const selectTeamJobsCount = (teamId?: string) => (root: { teams: TeamsState }) =>
    teamId ? root.teams.jobsCounts[teamId] ?? 0 : 0;
